/**
 * Utility function to get the key value from a column object
 * @param {Object} column - The column object
 * @returns {string|null} The column key value (placeholderKey or uppercase realValue)
 */
export const getColumnValue = column => {
  return column?.placeholderKey ? column.placeholderKey : column?.realValue?.toUpperCase();
};
